/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/plan_name_available" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdPlanNameAvailable } from "./constants";
import type {
  GetEmailIpWarmingAppGroupIdPlanNameAvailableParams,
  GetEmailIpWarmingAppGroupIdPlanNameAvailableResult,
} from "./types";
import { isGetEmailIpWarmingAppGroupIdPlanNameAvailableResult } from "./validators";

export const getEmailIpWarmingAppGroupIdPlanNameAvailable = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdPlanNameAvailable,
  (
    signal: AbortSignal,
    { appGroupId, name, planId }: GetEmailIpWarmingAppGroupIdPlanNameAvailableParams
  ): Promise<GetEmailIpWarmingAppGroupIdPlanNameAvailableResult> => {
    return fetch(
      `/email/ip_warming/${appGroupId}/plan_name_available`,
      "GET",
      { name, plan_id: planId },
      { signal }
    );
  },
  isGetEmailIpWarmingAppGroupIdPlanNameAvailableResult
);
